import { createContext, useContext } from "react";

/**
 * Context value for RadioGroup
 * @property {boolean} hasError - Whether the group has an error state
 */
export type RadioGroupContextValue = {
  /**
   * Whether the radio group has an error state
   */
  hasError: boolean;
};

/**
 * Context for sharing state between RadioGroup and child Radio components
 */
export const RadioGroupContext = createContext<
  RadioGroupContextValue | undefined
>(undefined);

/**
 * Hook to access RadioGroup context from child Radio components
 * @returns RadioGroupContextValue if inside a RadioGroup, undefined otherwise
 */
export const useRadioGroupContext = () => {
  return useContext(RadioGroupContext);
};
